export default "__VITE_ASSET__BW$aulof__"